import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BatteryMetricItem, Theme } from "./utilization-metrics.interface";

@Component({
	selector: "app-utilization-metric-box",
	templateUrl: "./utilization-metric-box.component.html",
	styleUrls: ["./utilization-metric-box.component.css"],
})
export class UtilizationMetricBoxComponent {
	@Input() title: string;
	@Input() icon: string = 'key';
	@Input() items: BatteryMetricItem[] = [];
	@Input() theme: Theme = 'blue';
	@Input() showLegend: boolean = true;
	@Input() customSeverity: { [key: string]: number } = {};
	@Output() metricClicked = new EventEmitter<string>();
	constructor() {}

	onLabelClick(item: BatteryMetricItem) {
		if (item.name) {
			this.metricClicked.emit(item.name);
		}
	}

	getSeverity(value: number): BatteryMetricItem["severity"] {
		switch (true) {
			case value > (this.customSeverity?.critical || 10):
				return "Critical";
			case value > (this.customSeverity?.high || 5):
				return "High";
			case value >= (this.customSeverity?.moderate || 3):
				return "Moderate";
			default:
				return "Low";
		}
	}
}
